import {Home, Newspaper, Pencil, Search, UserRound} from 'lucide-react'
import { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { colonyProfilePath } from '@/lib/colonyProfile'
import { WalletAddressContext } from '@/lib/walletContext'

function dockClass(isActive: boolean) {
  return `flex min-h-12 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-0.5 py-1.5 text-[10px] font-semibold tracking-tight transition-colors ${
    isActive
      ? 'bg-lime-400/15 text-lime-400'
      : 'text-zinc-400 hover:bg-white/5 hover:text-white'
  }`
}

function MobileColonyDock() {
  const wallet = useContext(WalletAddressContext)
  const ownProfileTo = colonyProfilePath(wallet)
  const viewProfileTo = wallet ? ownProfileTo : '/my-colony'

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-black/90 px-1.5 pt-1.5 pb-[max(0.5rem,env(safe-area-inset-bottom))] backdrop-blur-xl md:hidden"
      aria-label="Colony shortcuts"
    >
      <div className="mx-auto flex max-w-lg items-stretch gap-0.5">
        <NavLink to="/" end className={({ isActive }) => dockClass(isActive)}>
          <Home className="h-5 w-5" aria-hidden="true" />
          Home
        </NavLink>
        <NavLink to="/explore-colony" className={({ isActive }) => dockClass(isActive)}>
          <Search className="h-5 w-5" aria-hidden="true" />
          Search
        </NavLink>
        <NavLink to="/colony-newsfeed" className={({ isActive }) => dockClass(isActive)}>
          <Newspaper className="h-5 w-5" aria-hidden="true" />
          News feed
        </NavLink>
        <NavLink
          to={viewProfileTo}
          className={({ isActive }) => dockClass(Boolean(wallet) && isActive)}
        >
          <UserRound className="h-5 w-5" aria-hidden="true" />
          View Profile
        </NavLink>
        <NavLink to="/my-colony" className={({ isActive }) => dockClass(isActive)}>
          <Pencil className="h-5 w-5" aria-hidden="true" />
          Edit profile
        </NavLink>
      </div>
    </nav>
  )
}

export default MobileColonyDock
